import { useEffect, useState } from 'react';
import { IDynamicContentResponse, IDynamicContentFetchDataFunc } from 'types';

function useDynamicContent<T>(
  fetchData: IDynamicContentFetchDataFunc<T>,
  data: T | null
): IDynamicContentResponse<T | null> {
  const [loading, setLoading] = useState<boolean>(false);
  const [dynamicContent, setDynamicContent] = useState<T | null>(data);

  useEffect(() => {
    async function fetchDynamicContent(): Promise<void> {
      let timeout;
      try {
        timeout = setTimeout(() => {
          setLoading(false);
        }, 100);
        const response = await fetchData();

        setDynamicContent(response);
      } catch (e) {
        clearTimeout(timeout);
        setLoading(false);
        console.error(e);
      }
    }
    // fetchDynamicContent();
  }, []);

  return {
    loading,
    data: dynamicContent
  };
}

export default useDynamicContent;
